<template>
  <div class="leco-content">
    <div class="page-title">
      <div class="">直近のトレーニング予定一覧</div>
      <div class="training-search-input-wrap">
        <div v-if="search_tag_id != 0" class="search-tag-label">
          <span class="search-tag-label-text">{{ this.search_tag_name }}</span>
          <font-awesome-icon icon="fa-solid fa-xmark" class="search-tag-xmark" @click="removeSearchTag()" />
        </div>
        <input class="training-search-input" type="text" v-model="search_keyword" placeholder="検索したい用語を入れてください"
          @keypress.enter="onSearchTraining(search_tag_id)" />
        <div class="btn btn-outline-secondary training-search-btn" style="padding: 0.14em 0.75em; margin-left: 5px"
          @click="onSearchTraining(search_tag_id)">
          検索
        </div>
      </div>
    </div>
    <div class="content-inner">
      <div v-if="(trainingPlans.length > 0) * (futureTrainingPlans.length > 0)" class="btn future-display-btn"
        @click="displayFuturePlan">
        <font-awesome-icon icon="fa-angles-up" class="mr-3" />もっと先の予定を表示：{{ futureTrainingPlans.length }}件
        <font-awesome-icon icon="fa-angles-up" class="ml-3" />
      </div>
      <table class="table table-hover training-schedule-tbl" :class="trainingScheduleTblClass" width="80%"
        margin-left="10px">
        <thead>
          <tr>
            <th class="tra-sche-clm-name">
              <span class="head-training-title">トレーニング名</span>
            </th>
            <th class="tra-sche-clm-date">日時</th>
            <th class="tra-sche-clm-coach">講師</th>
            <th class="tra-sche-clm-place">会場</th>
            <th class="tra-sche-clm-operation-menu"></th>
          </tr>
        </thead>
        <transition-group tag="tbody" name="training-plan-list">
          <tr v-for="(trainingPlan, recIndex) in trainingPlans" v-bind:key="trainingPlan.id"
            :class="trainingPlan.term_type">
            <!--training_name-->
            <td class="tra-sche-clm-name">
              <div class="training-name-container d-flex justify-content-between align-items-center">
                <div>
                  <div class="training-name-text">
                    {{ trainingPlan.training_planning_name }}
                  </div>
                  <!--sub_category_name-->
                  <div class="sub-category-tag" @click="addSearchTag(trainingPlan.training_sub_category_id)">
                    {{ trainingPlan.training_sub_category_name }}
                  </div>
                </div>
                <div class="today-label" v-if="judgeToday(trainingPlan.start)">
                  Today
                </div>
              </div>
            </td>

            <!--datetime_from-->
            <td class="tra-sche-clm-date">
              <div class="tra-sche-datetime">
                <div class="tra-sche-date">
                  {{ trainingPlan.start | moment("YYYY/MM/DD") }}
                </div>
                <div class="tra-sche-time">
                  {{ trainingPlan.start | moment("HH:mm") }}-{{
                    trainingPlan.end | moment("HH:mm")
                  }}
                </div>
              </div>
            </td>

            <!--coach_name-->
            <!--2人まではそのまま表示、3人以上は他N名表示-->
            <td class="tra-sche-clm-coach">
              <div v-for="(coach_info, coachIndex) in trainingPlan.coaches" :key="coach_info.tpc_id">
                <div v-if="coachIndex == 0">
                  <div class="coach-family-name float-left">
                    {{ coach_info.coach_family_name }}
                  </div>
                  <div class="coach-given-name float-left">
                    {{ coach_info.coach_given_name }}
                  </div>
                  <div class="clearfix"></div>
                </div>
                <div v-else-if="
                  coachIndex == 1 && trainingPlan.coaches.length == 2
                ">
                  <div class="coach-family-name float-left">
                    {{ coach_info.coach_family_name }}
                  </div>
                  <div class="coach-given-name float-left">
                    {{ coach_info.coach_given_name }}
                  </div>
                  <div class="clearfix"></div>
                </div>
                <div v-else-if="coachIndex == 1 && trainingPlan.coaches.length > 2">
                  <span v-tooltip.bottom="getOtherCoaches(recIndex)">
                    他{{ trainingPlan.coach_count - 1 }}名
                  </span>
                </div>
              </div>
            </td>

            <!--place-->
            <td class="tra-sche-clm-place leco-link-color">
              <!-- v-ifでteams録画を見る表示切り替え -->
              <div class="float-left tra-sche-web-meeting-join-icon" v-if="
                trainingPlan.web_meeting_rec_url !== '' &&
                trainingPlan.web_meeting_rec_url !== null
              " v-tooltip="'録画を見る'">
                <router-link :to="{
                  name: 'web-meeting-rec-watch-redirect',
                  params: { id: trainingPlan.id }
                }">
                  <div class="tra-sche-place">
                    <div class="place-icon-area">
                      <font-awesome-icon icon="play-circle" style="margin: 0 2px" />
                    </div>
                    <div class="place-text">
                      {{ trainingPlan.place }}
                    </div>
                  </div>
                </router-link>
              </div>
              <!-- v-ifでteamsで参加する表示切り替え -->
              <div class="tra-sche-web-meeting-join-icon" v-else-if="
                trainingPlan.join_url !== '' &&
                trainingPlan.join_url !== null
              " v-tooltip="'Teamsで参加する'">
                <a :href="trainingPlan.join_url" target="_blank">
                  <div class="tra-sche-place">
                    <div class="place-icon-area">
                      <font-awesome-icon icon="door-open" />
                    </div>
                    <div class="place-text">{{ trainingPlan.place }}</div>
                  </div>
                </a>
              </div>
              <!-- v-ifでteamsのURL発行なし表示切り替え -->
              <div v-else class="tra-sche-web-meeting-join-icon" v-tooltip="'TeamsのURLはLECOから発行されませんでした。講師から連絡されるURLから参加してください。'
                ">
                <div class="tra-sche-place">
                  <div class="lace-icon-area">
                    <font-awesome-layers>
                      <font-awesome-icon icon="door-closed" style="color: #6c757d" />
                      <font-awesome-icon icon="slash" transform="down-2 left-3" size="lg" style="color: white" />
                      <font-awesome-icon icon="slash" transform="down-0 left-3" size="lg" style="color: #6c757d" />
                    </font-awesome-layers>
                  </div>
                  <div class="place-text">{{ trainingPlan.place }}</div>
                </div>
              </div>
            </td>

            <!--Feedback Form-->
            <td class="tra-sche-clm-operation-menu">
              <div class="tra-sche-ope-btns">
                <div>
                  <router-link :to="{
                    name: 'questionnaire-answer',
                    params: { id: trainingPlan.id }
                  }" class="btn btn-outline-secondary tra-ope-btn feedback-btn pc-only-menu"
                    v-tooltip.top="'FeedBackを書く'" aria-label="FeedBackを書く">
                    <font-awesome-icon icon="user-edit" />
                  </router-link>

                  <!--Feedback Summary-->
                  <router-link :to="{
                    name: 'questionnaire-answer-result',
                    params: { id: trainingPlan.id }
                  }" class="btn btn-outline-secondary tra-ope-btn feedback-btn feedback-summary-btn pc-only-menu"
                    v-tooltip.top="'FeedBackの結果を見る'" aria-label="FeedBackの結果を見る">
                    <font-awesome-icon icon="chart-pie" />
                    <span class="questionnaire-answer-count">
                      {{ trainingPlan.questionnaire_answer_count }}
                    </span>
                  </router-link>
                </div>
                <div>
                  <!--Training material url-->
                  <a :href="trainingPlan.training_material_url" target="_blank"
                    class="btn btn-outline-secondary tra-ope-btn training-material-btn pc-only-menu"
                    v-tooltip.top="'トレーニング資料'" aria-label="トレーニング資料を見る" :class="{
                      disabled:
                        trainingPlan.training_material_url == null ||
                        trainingPlan.training_material_url == ''
                    }">
                    <font-awesome-icon icon="folder-open" />
                  </a>

                  <!--Training plan change-->
                  <router-link :to="{
                    name: 'training-plan-update',
                    params: { id: trainingPlan.id }
                  }" class="btn btn-outline-secondary tra-ope-btn tra-change-btn pc-only-menu"
                    v-tooltip.top="'予定を変更する'" aria-label="予定を変更する">
                    <font-awesome-icon icon="cog" />
                  </router-link>
                </div>
              </div>
              <!-- コンポーネント MenuModal -->
              <div class="btn btn-outline-secondary tra-change-btn subMenuIcon smart-phone-only" @click="
                openModal(
                  $event,
                  trainingPlan.join_url,
                  trainingPlan.web_meeting_rec_url,
                  trainingPlan.id,
                  trainingPlan.questionnaire_answer_count,
                  trainingPlan.training_material_url
                )
                " v-tooltip.top="'その他メニュー'">
                <font-awesome-icon icon="ellipsis-h" />
                <!-- コンポーネント MenuModal -->
              </div>
            </td>
          </tr>
        </transition-group>
      </table>
      <infinite-loading @infinite="infiniteHandler" spinner="spiral">
        <div class="mb-4" slot="no-results">
          トレーニングがまだ登録されていません。
        </div>
        <div class="mb-4" slot="no-more">
          これより過去のトレーニングはありません。
        </div>
        <div class="mb-4" slot="error">
          トレーニングの取得中にエラーが発生しました。
        </div>
      </infinite-loading>
    </div>
    <!-- サブメニューモーダル -->
    <div class="modal modal-overlay" @click="closeModal" v-if="modal">
      <MenuModal @close="closeModal" :style="{
        transform:
          'translateX(' +
          (this.subMenuX - 166) +
          'px) ' +
          'translateY(' +
          (this.subMenuY + 5) +
          'px)'
      }">
        <div>
          <!-- default スロットコンテンツ -->
          <!-- Teams参加用URL -->
          <router-link :to="{
            name: 'questionnaire-answer',
            params: { id: this.subMenuTrainingPlanId }
          }">
            <div class="modal-sub-menu">
              <font-awesome-icon icon="user-edit" class="modal-sub-menu-icon-area" />
              <span class="modal-sub-menu-text">FBを書く</span>
            </div>
          </router-link>
          <router-link :to="{
            name: 'questionnaire-answer-result',
            params: { id: this.subMenuTrainingPlanId }
          }" v-tooltip.top="'FeedBackの結果を見る'">
            <div class="modal-sub-menu">
              <span class="modal-sub-menu-icon-area">
                <font-awesome-icon icon="chart-pie" />
                <span class="questionnaire-answer-count">
                  {{ this.subMenuQuestionnaireAnswerCount }}
                </span>
              </span>
              <span class="modal-sub-menu-text">FBの結果を見る</span>
            </div>
          </router-link>

          <a v-if="
            this.trainingMaterialUrl !== null &&
            this.trainingMaterialUrl !== ''
          " :href="this.trainingMaterialUrl" target="_blank" v-tooltip.top="'トレーニング資料'" :class="{
            'modal-link-disabled':
              this.trainingMaterialUrl == null ||
              this.trainingMaterialUrl == ''
          }">
            <div class="modal-sub-menu">
              <font-awesome-icon icon="folder-open" class="modal-sub-menu-icon-area" />
              <span class="modal-sub-menu-text">資料を見る</span>
            </div>
          </a>
          <div v-else>
            <div class="modal-sub-menu modal-link-disabled">
              <font-awesome-icon icon="folder-open" class="modal-sub-menu-icon-area" />
              <span class="modal-sub-menu-text">（資料未登録）</span>
            </div>
          </div>

          <!-- トレーニング予定更新 -->
          <router-link :to="{
            name: 'training-plan-update',
            params: { id: this.subMenuTrainingPlanId }
          }">
            <div class="modal-sub-menu">
              <font-awesome-icon icon="cog" class="modal-sub-menu-icon-area" />
              <span class="modal-sub-menu-text">予定を変更する</span>
            </div>
          </router-link>
          <!-- /default -->
          <!-- /footer -->
        </div>
      </MenuModal>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { API_BASE_URL } from "@/common/config";
import moment from "moment";
import MenuModal from "@/components/LECO_TrainingPlanMenuModal.vue";

// infinite scroll Setup
import InfiniteLoading from "vue-infinite-loading";
Vue.use(InfiniteLoading);

// v-tooltip Setup
import VTooltip from "v-tooltip";
Vue.use(VTooltip);

// FontAwesome Setup
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChartPie,
  faEllipsisH,
  faUserEdit,
  faPlayCircle,
  faDoorOpen,
  faDoorClosed,
  faSlash,
  faCog,
  faFolderOpen,
  faAngleDoubleUp,
  faXmark
} from "@fortawesome/free-solid-svg-icons";
import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";
library.add(
  faChartPie,
  faEllipsisH,
  faUserEdit,
  faPlayCircle,
  faDoorOpen,
  faDoorClosed,
  faSlash,
  faCog,
  faFolderOpen,
  faAngleDoubleUp,
  faXmark
);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);

const API_GET_LIMIT = 30;

export default {
  name: "training_plannings",
  components: { MenuModal },
  data() {
    return {
      trainingPlans: [],
      futureTrainingPlans: [],
      logger: this.$store.state.logger,
      modal: false,
      message: "",
      subMenuX: 500,
      subMenuY: 100,
      subMenuWhenScrollY: 0,
      subMenuTeamsJoinUrl: "",
      subMenuTeamsRecUrl: "",
      subMenuTrainingPlanId: 0,
      subMenuQuestionnaireAnswerCount: 0,
      trainingMaterialUrl: "",
      apiGetOffset: 0,
      trainingScheduleTblClass: "future-training-hide",
      search_keyword: "",
      search_tag_id: 0,
      search_tag_name: ""
    };
  },
  filters: {
    moment(date, format) {
      return moment(date).format(format);
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  //一覧画面表示時に、トレーニング予実データを取得する
  created() {
    // 画面スクロールをトップにする
    this.instantScrollTop();

    var search_key_query = this.$route.query.q;
    this.logger.debug("created search_key textbox loaded=" + search_key_query);
    if (search_key_query != undefined) {
      this.search_keyword = search_key_query;
    } else {
      this.search_keyword = "";
    }

    // データ取得はinfiniteHandler()で行うためここでは何もしない
  },
  methods: {
    // 引数で指定された配列の他講師名を取得する
    getOtherCoaches(index) {
      return this.trainingPlans[index].other_coach_name;
    },
    openModal(
      event,
      webMeetingJoinUrl,
      webMeetingRecUrl,
      id,
      QuestionnaireAnswerCount,
      trainingMaterialUrl
    ) {
      this.logger.debug(event.target);
      // ダイアログの表示位置を設定するためにクリックされた位置を取得
      if (event.target.classList.contains("subMenuIcon") == true) {
        this.subMenuX = event.target.getBoundingClientRect().left;
        this.subMenuY = event.target.getBoundingClientRect().bottom;
      } else {
        if (event.target.parentNode.classList.contains("subMenuIcon") == true) {
          this.subMenuX = event.target.parentNode.getBoundingClientRect().left;
          this.subMenuY =
            event.target.parentNode.getBoundingClientRect().bottom;
        } else {
          if (
            event.target.parentNode.parentNode.classList.contains(
              "subMenuIcon"
            ) == true
          ) {
            this.subMenuX =
              event.target.parentNode.parentNode.getBoundingClientRect().left;
            this.subMenuY =
              event.target.parentNode.parentNode.getBoundingClientRect().bottom;
          }
        }
      }
      this.subMenuWhenScrollY = window.scrollY;
      this.logger.debug("clicked. X:" + this.subMenuX + ", Y:" + this.subMenuY);

      // リンク先のURL等の設定
      this.subMenuTeamsJoinUrl = webMeetingJoinUrl;
      this.subMenuTeamsRecUrl = webMeetingRecUrl;
      this.subMenuTrainingPlanId = id;
      this.subMenuQuestionnaireAnswerCount = QuestionnaireAnswerCount;
      this.trainingMaterialUrl = trainingMaterialUrl;
      this.modal = true;
    },
    closeModal() {
      this.logger.debug("modal=falseに設定");
      this.modal = false;
    },
    handleScroll() {
      if (this.subMenuWhenScrollY != window.scrollY) {
        this.modal = false;
      }
    },
    judgeToday(startTime) {
      var check_target = new Date(startTime);
      var now = new Date();

      // 当日0時を設定
      var today_start = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        0,
        0,
        0,
        0
      );

      // 翌日0時を設定
      var today_end = new Date(today_start);
      today_end = new Date(today_end.setDate(today_end.getDate() + 1));

      if (
        check_target.getTime() >= today_start.getTime() &&
        check_target.getTime() < today_end.getTime()
      ) {
        return true;
      } else {
        return false;
      }
    },
    judgeFuture(startTime) {
      const DISPLAY_LIMIT_DAYS = 31;
      var check_target = new Date(startTime);
      var now = new Date();

      // 当日0時を設定
      var display_limit_date = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        0,
        0,
        0,
        0
      );
      display_limit_date.setDate(
        display_limit_date.getDate() + DISPLAY_LIMIT_DAYS
      );

      if (check_target.getTime() >= display_limit_date.getTime()) {
        return true;
      } else {
        return false;
      }
    },
    getPastTodayFutureClass(startTime) {
      var check_target = new Date(startTime);
      var now = new Date();

      // 当日0時を設定
      var today_start = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        0,
        0,
        0,
        0
      );

      // 翌日0時を設定
      var today_end = new Date(today_start);
      today_end = new Date(today_end.setDate(today_end.getDate() + 1));

      // 1週間後を設定
      var OneWeekAfterDate = new Date();
      OneWeekAfterDate.setDate(today_end.getDate() + 29);

      if (
        check_target.getTime() >= today_start.getTime() &&
        check_target.getTime() < today_end.getTime()
      ) {
        return "tra-sche-today-row";
      } else if (check_target.getTime() >= OneWeekAfterDate.getTime()) {
        return "tra-sche-one-month-later-future-row";
      } else if (check_target.getTime() >= today_end.getTime()) {
        return "tra-sche-future-row";
      } else if (check_target.getTime() < today_start.getTime()) {
        return "tra-sche-past-row";
      }
    },
    async infiniteHandler($state) {
      // トレーニング予定を取得する
      const res = await this.getTrainingPlan(
        this.apiGetOffset,
        this.search_keyword
      );

      if (res.data.body.length == 0) {
        // 表示するデータが無くなった場合
        $state.complete();
      } else {
        // コーチが2名以上の場合の省略処理
        res.data.body = this.adjustCoach(res.data.body);

        // 未来と当日以前のデータを分解
        res.data.body.forEach((traPlan) => {
          traPlan["term_type"] = this.getPastTodayFutureClass(traPlan["start"]);
          if (this.judgeFuture(traPlan.start)) {
            this.futureTrainingPlans.push(traPlan);
          } else {
            this.trainingPlans.push(traPlan);
          }
        });

        // タグ検索の場合、タグ情報を表示
        if (this.$route.query.tag != undefined) {
          this.search_tag_id = res.data.tags[0].id;
          this.search_tag_name = res.data.tags[0].name;
        }

        // オフセットを変更
        this.apiGetOffset = this.apiGetOffset + API_GET_LIMIT;

        $state.loaded();
      }
    },
    async getTrainingPlan(offset, search_keyword) {
      this.logger.info("getTrainingPlan() offset=" + this.apiGetOffset);

      var search_key_query = this.$route.query.q;
      this.logger.debug("search_key_query=" + search_key_query);
      if (search_key_query != undefined) {
        search_key_query = "&q=" + search_key_query;
      } else {
        search_key_query = "";
      }

      var search_tag_query = this.$route.query.tag;
      this.logger.debug("search_tag_query=" + search_tag_query);
      if (search_tag_query != undefined) {
        search_tag_query = "&tag=" + search_tag_query;
      } else {
        search_tag_query = "";
      }

      let api_url;
      api_url =
        API_BASE_URL +
        "training-plannings?offset=" +
        offset +
        "&limit=" +
        API_GET_LIMIT +
        search_key_query +
        search_tag_query;
      try {
        this.logger.debug("api uri=" + api_url);
        const response = await axios.get(api_url, {
          headers: {
            Authorization: this.$store.getters.currentUser.idToken.jwtToken
          }
        });

        if ("statusCode" in response.data) {
          if (response.data.statusCode == 200) {
            this.logger.info(
              "トレーニング予定取得APIデータ取得完了。training_count = " +
              response.data.body.length
            );
            this.logger.debug(JSON.stringify(response.data));
            return response;
          } else {
            this.logger.error("API unexpected status error");
            this.logger.error(JSON.stringify(response));
            this.$router.push("/system-error500");
          }
        } else {
          this.logger.error("API unexpected response format error");
          this.logger.error(JSON.stringify(response));
          this.$router.push("/system-error500");
        }
      } catch (error) {
        this.logger.error("error in get training plan");
        this.logger.error(JSON.stringify(error));
        this.$router.push("/system-error500");
      }

      this.logger.debug("getTrainingPlan finished");
    },
    async displayFuturePlan() {
      // 順に追加するので逆順にリバース
      this.futureTrainingPlans = this.futureTrainingPlans.slice().reverse();
      // 1つずつ追加
      this.futureTrainingPlans.forEach((plan) => {
        this.trainingPlans.splice(0, 0, plan);
      });

      // 未来の予定をクリアし、ボタン分の余白クラスを削除
      this.futureTrainingPlans = [];
      this.trainingScheduleTblClass = "";

      setTimeout(this.clearFutureBackgroundColor, 5000);
    },
    clearFutureBackgroundColor() {
      console.log("call clearFutureBackgroundColor.");
      this.trainingPlans.forEach((plan) => {
        if (plan["term_type"] == "tra-sche-one-month-later-future-row") {
          plan["term_type"] = "tra-sche-future-row";
        }
      });
    },
    adjustCoach(trainings) {
      this.logger.debug("adjustCoach() offset=" + this.apiGetOffset);
      // 一覧上の複数講師表示のため、講師数や他講師名の情報をtrainingPlansに追加する
      for (let i = 0; i < trainings.length; i++) {
        trainings[i]["other_coach_name"] = "";
        trainings[i]["coach_count"] = trainings[i]["coaches"].length;
        this.logger.debug(
          "checking id:" +
          trainings[i]["id"] +
          ", training_name:" +
          trainings[i]["training_planning_name"]
        );
        // 講師が3名以上の場合だけ省略する
        if (trainings[i].coaches.length > 2) {
          // 講師の「他n名」のTooltips用の文字列連結
          for (let j = 0; j < trainings[i].coaches.length; j++) {
            if (j > 0) {
              // カンマ区切り（先頭は不要）
              if (j > 1) trainings[i]["other_coach_name"] += "<br /> ";
              trainings[i]["other_coach_name"] +=
                trainings[i].coaches[j].coach_name;
            }
          }
        } else {
          //講師が2名以下の場合は省略しない
          trainings[i]["other_coach_name"] = "";
        }
      }
      return trainings;
    },
    onSearchTraining(tag_id) {
      this.logger.debug(
        "onSearchTraining() search_keyword=" + this.search_keyword
      );

      var query = {};
      if (this.search_keyword != "") {
        query.q = this.search_keyword;
      }

      if (tag_id != 0) {
        query.tag = tag_id;
      }

      this.$router
        .push({
          path: "/",
          query: query
        })
        .catch((err) => {
          location.reload();
        });
    },
    addSearchTag(tag_id) {
      this.onSearchTraining(tag_id);
    },
    removeSearchTag() {
      this.search_tag_id = 0;
      this.search_tag_name = "";
      this.onSearchTraining();
    },
  },
  watch: {
    // 同一画面遷移だとVue.jsはリロードしないので、URLパラメータの変更を監視してリロードする
    $route() {
      location.reload();
    }
  }
};
</script>

<style scoped>
.smart-phone-only {
  display: none;
}

.training-search-input-wrap {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.search-tag-label {
  margin: 0px 1.1em .10em 0;
  padding: 6px 16px;
  line-height: 1;
  text-decoration: none;
  color: gray;
  border: 1px solid gray;
  border-radius: 2em;
  font-size: 80%;
  background-color: white;
  font-weight: 100;
}

.search-tag-label-text {
  margin-right: 8px;
}

.search-tag-label-text:before {
  content: "#";
}

.search-tag-xmark {
  cursor: pointer;
}

.training-search-input {
  width: 280px;
}

.future-training-hide tr:first-child td {
  padding-top: 42px;
}

.tra-sche-one-month-later-future-row td {
  background: rgb(255, 255, 238);
  transition: all 2s;
}

.tra-sche-future-row td,
.tra-sche-today-row td,
.tra-sche-past-row td {
  background: none;
  transition: background 3s;
}

.future-display-btn {
  position: absolute;
  left: 50%;
  top: 170px;
  transform: translate(-50%);
  background: #ffe9c9;
  color: #1e354b;
  border-radius: 24px;
  padding: 2px 78px;
}

.future-display-btn:hover {
  background: #fec979;
}

.training-schedule-tbl th {
  position: sticky;
  top: 0;
  background: #f3f4f7;
  z-index: 100;
}

.tra-sche-today-row {
  font-weight: 700;
}

.training-name-container {
  display: flex;
  justify-content: space-between;
  align-items: center;  /* Changed from flex-start to center for vertical alignment */
  width: 100%;
  padding: 4px 0;  /* Added padding for better spacing */
}

.today-label {
  background: #6c757d;
  border-radius: 24px;
  padding: 1px 10px;
  color: white;
  font-size: 0.9em;
  text-align: center;
  min-width: 65px;
  margin-left: 8px;
  align-self: center;  /* Changed from flex-start to center to match container */
}

.coach-family-name {
  margin-right: 5px;
}

/* 一覧のカラム横幅指定（PC） */
.tra-sche-clm-name {
  width: 33%;
}

.tra-sche-clm-today {
  width: 7%;
}

.tra-sche-clm-date {
  width: 18%;
}

.tra-sche-clm-coach {
  width: 14%;
}

.tra-sche-clm-place {
  width: 9%;
}

.tra-sche-clm-operation-menu {
  width: 19%;
}

.feedback-summary-btn {
  margin-left: 5px;
  width: 63px;
}

.training-material-btn {
  margin-left: 5px;
  padding: 6px 10px;
}

.training-schedule-tbl {
  word-break: break-all;
}

.training-schedule-tbl td {
  vertical-align: middle;
}

.place-icon-area {
  min-width: 24px;
  margin-right: 0px;
}

.tra-sche-web-meeting-join-icon {
  margin-left: 8px;
}

.questionnaire-answer-count {
  font-size: 75%;
  color: #000000 !important;
}

.tra-change-btn {
  margin-left: 20px;
}

.sub-category-tag {
  display: inline-block;
  margin: 0 .1em .10em 0;
  padding: .3em .6em;
  line-height: 1;
  text-decoration: none;
  color: gray;
  border: 1px solid gray;
  border-radius: 2em;
  font-size: 75%;
  cursor: pointer;
}

.sub-category-tag:hover {
  background-color: #6c757d;
  color: white;
}

.sub-category-tag:before {
  content: "#";
}

.tra-sche-datetime {
  display: flex;
}

.tra-sche-time {
  margin-left: 0.5em;
}

.tra-sche-place {
  display: flex;
}

.place-text {
  margin-left: 10px;
}

.tra-sche-ope-btns {
  display: flex;
}

.modal.modal-overlay {
  display: flex;
  position: fixed;
  z-index: 30;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.modal-content a,
.tra-sche-clm-place a {
  color: var(--leco-link-color);
}

.modal-sub-menu {
  margin: 10px;
}

.web-meeting-join-btn {
  margin-right: 20px;
}

.modal-sub-menu-icon-area {
  width: 30px;
}

.modal-sub-menu-text {
  margin-left: 15px;
}

.modal-link-disabled {
  color: #ffc6b8;
}

/* スマホ向け */
@media screen and (max-width: 670px) {
  .content-inner {
    margin-left: 10px;
    margin-right: 10px;
  }

  .training-search-input-wrap {
    margin-right: 5px;
    margin-top: 3px;
  }

  .future-display-btn {
    top: 323px;
    width: 80%;
    font-size: var(--under600-font-size);
    padding: 2px 20px;
  }

  .training-search-input {
    height: 30px;
  }

  .training-search-btn {
    height: 30px;
  }

  /* 一覧のカラム横幅指定（スマホ） */
  .tra-sche-clm-name {
    width: calc(100% - 270px);
  }

  .head-training-title {
    font-size: 0;
  }

  .head-training-title:before {
    font-size: var(--under600-font-size);
    content: "名称";
  }

  .tra-sche-datetime {
    display: block;
  }

  .tra-sche-time {
    margin-left: 0em;
  }

  .tra-sche-clm-date {
    width: 90px;
  }

  .tra-sche-clm-coach {
    width: 80px;
  }

  .tra-sche-clm-place {
    width: 60px;
  }

  .tra-sche-clm-operation-menu {
    width: 40px;
  }

  .training-schedule-tbl td {
    vertical-align: top;
  }

  .tra-sche-place {
    display: block;
  }

  .place-text {
    margin-left: 0px;
  }

  .tra-sche-ope-btns {
    display: block;
  }

  .pc-only-menu {
    display: none;
  }

  .smart-phone-only {
    display: block;
  }

  .tra-change-btn {
    padding: 4px;
  }

  .tra-change-btn {
    width: 85%;
    margin-top: 3px;
  }

  .tra-change-btn {
    margin-left: 0px;
  }

  .table th,
  .table td {
    padding-right: 0px;
    padding-left: 6px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
}

/* タブレット向け */
@media screen and (min-width: 671px) and (max-width: 1240px) {
  .future-display-btn {
    top: 272px;
    width: 50%;
    padding: 2px 20px;
  }

  .tra-sche-clm-name {
    width: calc(100% - 654px);
  }

  .tra-sche-clm-today {
    width: 90px;
  }

  .tra-sche-clm-date {
    width: 120px;
  }

  .tra-sche-clm-coach {
    width: 104px;
  }

  .tra-sche-clm-place {
    width: 90px;
  }

  .tra-sche-clm-operation-menu {
    width: 180px;
  }

  .tra-ope-btn {
    width: 70px;
    margin: 3px;
  }

  .tra-sche-datetime {
    display: block;
  }

  .tra-sche-time {
    margin-left: 0em;
  }

  .tra-sche-place {
    display: block;
  }

  .place-text {
    margin-left: 0px;
  }

  .tra-sche-ope-btns {
    display: block;
  }
}

/* loadingアイコン用CSS */
.loader {
  font-size: 10px;
  margin: 50px auto;
  text-indent: -9999em;
  width: 5em;
  height: 5em;
  border-radius: 50%;
  background: #000000;
  background: -moz-linear-gradient(left,
      #000000 10%,
      rgba(255, 255, 255, 0) 42%);
  background: -webkit-linear-gradient(left,
      #000000 10%,
      rgba(255, 255, 255, 0) 42%);
  background: -o-linear-gradient(left, #000000 10%, rgba(255, 255, 255, 0) 42%);
  background: -ms-linear-gradient(left,
      #000000 10%,
      rgba(255, 255, 255, 0) 42%);
  background: linear-gradient(to right,
      #000000 10%,
      rgba(255, 255, 255, 0) 42%);
  position: relative;
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}

.loader:before {
  width: 50%;
  height: 50%;
  background: #000000;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}

.loader:after {
  background: #ffffff;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
